import useGameReviewBase from './useGameReviewBase';

/**
 * Custom hook for BackgammonGameReview component
 * Manages state and business logic for the Backgammon game review page
 */
const useBackgammonGameReview = (activityFormData) => {
  return useGameReviewBase(activityFormData);
};

export default useBackgammonGameReview;
